import { Injectable, Inject } from "@angular/core";

import { AppStore, AppAction, UIAction, PageActions, GlobalDataActions } from "../../state";
import { RequestViews } from "../../models";
import { ImmutableObject } from "../../../../shared/immutableObject";
import { BaseActionCreator } from "../../baseActionCreator";

@Injectable()
export class PageActionCreator extends BaseActionCreator {

  constructor(
    @Inject(AppStore) public appStore: AppStore
  ) {
    super(null);
  }

  dispatchPageIdentifierIncrement = (pageId: number) => this.appStore.dispatch(this.pageIdentifierIncrement(pageId)) as UIAction<any>;
  pageIdentifierIncrement(pageId: number): UIAction<any> {

    return {
      type: PageActions.INCREMENT_PAGE_IDENTITY, id: -1, executeAsync: null, pageId: pageId
    }
  }

  dispatchAddConfiguratorPageUIData = (pageIdentifier) => this.appStore.dispatch(this.addConfiguratorPageUIData(pageIdentifier)) as AppAction<any>;
  addConfiguratorPageUIData(pageIdentifier: number): UIAction<any> {
    return {
      type: PageActions.CREATE_CONFIGURATOR_PAGE_UI_DATA, pageId: pageIdentifier, executeAsync: null
    }
  }

  dispatchAddConfUIData = (pageId, confId) => this.appStore.dispatch(this.addConfUIData(pageId, confId)) as UIAction<any>;
  addConfUIData(pageId: number, confId: number): UIAction<any> {
    return {
      type: PageActions.CREATE_CONF_UI_DATA, pageId: pageId, executeAsync: null, payload: confId
    }
  }

  dispatchUpdateState = (pageId: number, actionType: string, data: ImmutableObject) => this.appStore.dispatch(this.updateState(pageId, actionType, data)) as AppAction<ImmutableObject>;
  updateState(pageId: number, actionType: string, data: ImmutableObject): UIAction<ImmutableObject> {
    return {
      type: actionType, pageId: pageId, executeAsync: null, payload: data
    }
  }

  dispatchUpdateActiveView = (activeRouteName: string) => this.appStore.dispatch(this.updateActiveView(activeRouteName)) as AppAction<string>;
  updateActiveView(activeRouteName: string): UIAction<string> {
    return {
      type: PageActions.CONF_ACTIVE_ROUTE_NAME, executeAsync: null, payload: activeRouteName
    }
  }

}